<template>
  <b-table
    :items="items"
    :fields="headers"
    :busy="loading"
    :tbody-tr-class="rowClass"
    thead-class="list-header"
    borderless
    hover
    responsive
    show-empty
    @row-clicked="$emit('row-clicked', $event)"
  >
    <template #cell(company)="slotData">
      <span class="company-name">
        {{
          (slotData.item.company && slotData.item.company.fantasyName) || "—"
        }}
      </span>
    </template>

    <template #cell(user)="slotData">
      <span class="user-name">{{ slotData.item.fullname }}</span>
    </template>

    <template #cell(protocol)="slotData">
      <strong class="protocol-link">{{
        slotData.item.record && slotData.item.record.protocol
      }}</strong>
    </template>

    <template #cell(createdAt)="slotData">
      <span class="date-text">{{ slotData.item.createdAt | datetime }}</span>
    </template>

    <template #cell(verifiedBy)="slotData">
      <template v-if="slotData.item.verifiedBy">
        <i
          v-if="slotData.item.verifiedBy.company === null"
          class="fa fa-user-tie text-info"
          aria-hidden="true"
        ></i>
        <i v-else class="fa fa-user" aria-hidden="true"></i>
        <span class="ml-1">
          {{ slotData.item.verifiedBy.name }}
          {{ slotData.item.verifiedBy.surname }}
        </span>
      </template>
      <template v-else> — </template>
    </template>

    <template #cell(verifiedDate)="slotData">
      <span class="date-text">{{ slotData.item.verifiedDate | datetime }}</span>
    </template>

    <template #cell(status)="slotData">
      <i
        v-if="slotData.item.blocked"
        aria-hidden="true"
        class="fa fa-lock text-danger mr-1"
        title="Bloqueado"
      />
      <i
        v-else
        aria-hidden="true"
        class="fa fa-lock-open text-success mr-1"
        title="Liberado"
      />
      <i
        v-if="slotData.item.verified"
        aria-hidden="true"
        class="fa fa-user-check text-success"
        title="Verificado"
      />
      <i
        v-else
        aria-hidden="true"
        class="fa fa-user-xmark"
        title="Verificação Pendente"
      />
    </template>

    <template #table-busy>
      <div class="text-center py-5">
        <b-spinner></b-spinner>
        <span class="ml-2">Carregando...</span>
      </div>
    </template>
    <template #empty>
      <div class="text-muted text-center py-5">
        <i class="fas fa-check-circle fa-2x"></i>
        <p class="mt-3">Nenhuma menção encontrada</p>
      </div>
    </template>
  </b-table>
</template>

<script>
export default {
  name: "MentionsTable",
  props: {
    items: { type: Array, required: true },
    headers: { type: Array, required: true },
    loading: { type: Boolean, default: false },
  },
  methods: {
    rowClass() {
      return "mention-row";
    },
  },
};
</script>

<style scoped>
::v-deep .list-header th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  text-transform: uppercase;
  border: 0;
  white-space: nowrap;
}

::v-deep .list-header th.sortable:hover {
  color: #0056b3;
}

::v-deep .mention-row {
  cursor: pointer;
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.2s ease-in-out;
}

::v-deep .mention-row:hover {
  background-color: #e9ecef !important;
}

::v-deep tbody tr:last-of-type {
  border-bottom: none;
}

::v-deep .mention-row td {
  border-top: none;
  vertical-align: middle;
  padding: 0.85rem 0.75rem;
}

::v-deep .protocol-link {
  color: #007bff;
  font-weight: 500;
}

::v-deep .company-name,
::v-deep .user-name,
::v-deep .date-text {
  color: #6c757d;
}

::v-deep .action-icon {
  color: #6c757d;
  transition: color 0.2s;
}

::v-deep .mention-row:hover .action-icon {
  color: #007bff;
}
</style>
